import { frontendURL } from 'dashboard/helper/URLHelper';

const PERMISSIONS = ['administrator', 'agent', 'custom_role'];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/social-comments'),
    name: 'social_comments',
    meta: { permissions: PERMISSIONS },
    component: () => import('./SocialCommentsView.vue'),
  },
];
